import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NomenclatureItemService } from '@zaoblako/web/core/services/finance/nomenclature-item.service';
import { BaseSingleSelectComponent } from '@zaoblako/web/shared/components/base-single-select/base-single-select.component';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { NomenclatureTypeNamePipe } from '@zaoblako/web/shared/pipes/nomenclature-type-name.pipe';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import type { NomenclatureItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-find.dto';
import type { NomenclatureItemQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-query.dto';
import type { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';

import type { Observable } from 'rxjs';

@Component({
  selector: 'crm-nomenclature-item-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, NomenclatureTypeNamePipe, SafeHtmlPipe, SpinnerComponent],
  templateUrl: './nomenclature-item-single-select.component.html',
  styleUrls: ['./nomenclature-item-single-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NomenclatureItemSingleSelectComponent
  extends BaseSingleSelectComponent<NomenclatureItemFindInterface>
  implements OnInit, OnChanges {
  public availableModule = 'BASIS';

  @Input() public override placeholder = 'Выберите номенклатуру';

  @Input() public excludeZeroPrice = false;

  @Input() public set selectedNomenclature(selectedNomenclature: NomenclatureItemFindInterface) {
    this.selectedEntity = selectedNomenclature;
  }

  @Input() public set nomenclatures(nomenclatures: NomenclatureItemFindInterface[]) {
    this.entities = nomenclatures ?? [];
  }

  @Output() public selectedNomenclatureChange = new EventEmitter<NomenclatureItemFindInterface>();

  public override queryParams: NomenclatureItemQueryInterface = {
    limit: 40,
    offset: 0
  };

  public constructor(private readonly nomenclatureItemService: NomenclatureItemService) {
    super();
  }

  public ngOnInit(): void {
    this.syncListQueryParams();
    super.ngOnInit();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.excludeZeroPrice) {
      this.syncListQueryParams();
      if (!changes.excludeZeroPrice.firstChange) {
        this.firstLoad();
      }
    }
    super.ngOnChanges(changes);
  }

  private syncListQueryParams = (): void => {
    this.queryParams = {
      ...this.queryParams,
      excludeZeroPrice: this.excludeZeroPrice ? true : undefined
    };
  };

  public findById = (id: number): Observable<NomenclatureItemFindInterface> =>
    this.nomenclatureItemService.findById<NomenclatureItemFindInterface>(id);

  public findWithPagination = (
    queryParams: Partial<NomenclatureItemQueryInterface>
  ): Observable<PaginationFindInterface<NomenclatureItemFindInterface>> =>
    this.nomenclatureItemService.findWithPagination(queryParams as NomenclatureItemQueryInterface);

  public onSelectNomenclature = (nomenclature: NomenclatureItemFindInterface): void => {
    this.onSelect(nomenclature);
    this.selectedNomenclatureChange.emit(nomenclature);
  };

  public toNomenclature = (nomenclature: unknown): NomenclatureItemFindInterface =>
    nomenclature as NomenclatureItemFindInterface;
}
